import _ from 'lodash'
import { FieldArray } from 'react-final-form-arrays'

import { FormRow as _FormRow } from 'components/Form'
import AddButton from 'components/Buttons/BlankIconButtonAdd'
import { FloatingLabelFinalField } from 'components/FloatingLabelInput'

import TrashIcon from './TrashIcon'

const FormRow = styled(_FormRow)`
  align-items: flex-end;
  > div {
    flex: 1 1 50%;
  }
`

const EMPTY_FIELD = { uuid: null, email: null }

const EmailsArray = ({ fields: { value }, fields }) => {
  const isEmptyRow = !_.every(value, 'email')

  return (
    <div>
      {fields.map((name, index) => (
        <FormRow key={value[index].uuid || index}>
          <FloatingLabelFinalField
            id={`contact-form-${name}`}
            name={`${name}.email`}
            type="text"
            placeholder="Email"
          />

          <TrashIcon
            onClick={() => {
              fields.remove(index)
            }}
          />
        </FormRow>
      ))}

      {!isEmptyRow && (
        <AddButton
          onKeyDown={() => {}}
          onClick={() => fields.push(EMPTY_FIELD)}
        >
          Add Email
        </AddButton>
      )}
    </div>
  )
}

const EmailsArrayWrapper = () => {
  return <FieldArray name="email_addresses" component={EmailsArray} />
}

export default EmailsArrayWrapper
